var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',_vm._l((_vm.cols),function(col,idx){return _c('th',{key:idx,class:col.align},[_c('strong',[_vm._v(_vm._s(_vm.$t(col.i18n)))])])}))])}
var staticRenderFns = []

export { render, staticRenderFns }